<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GK3z05/tc-custom/9781429973182.jpg?1737547153518" alt="This image is the cover for the book Poser"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Poser
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“The long-awaited funny, smart, clear-headed, thoughtful, truthful, and inspiring yoga memoir. To simplify my praise: I absolutely loved this book.” —Elizabeth Gilbert, #1 </b><i><b>New York Times–</b></i><b>bestselling author</b><br/><br/>Ten years ago, Claire Dederer threw her back out breastfeeding her baby daughter. Told to try yoga by everyone from the woman behind the counter at the co-op to the homeless guy on the corner, she signed up for her first class. She fell madly in love.<br/><br/>Over the next decade, she would tackle triangle, wheel, and the dreaded crow, becoming fast friends with some poses and developing long-standing feuds with others. At the same time, she found herself confronting the forces that shaped her generation. Daughters of women who ran away to find themselves and made a few messes along the way, Dederer and her peers grew up determined to be good, good, good—even if this meant feeling hemmed in by the smugness of their organic-buying, attachment-parenting, anxiously conscientious little world. Yoga seemed to fit right into this virtuous program, but to her surprise, Dederer found that the deeper she went into the poses, the more they tested her most basic ideas of what makes a good mother, daughter, friend, wife—and the more they made her want something a little less tidy, a little more improvisational. Less goodness, more joy.<br/><br/><i>Poser</i> is unlike any other book about yoga you will read—because it is actually a book about life. Witty and heartfelt, sharp and irreverent, <i>Poser</i> is for anyone who has ever tried to stand on their head while keeping both feet on the ground.</p><p><b>“A powerful, honest, ruefully funny memoir.” —</b><i><b>The New York Times Book Review</b></i><br/><br/> </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Claire Dederer
      </h2>
      
      <p class="authorDescription body article"><P><B>Claire Dederer's</B> essays, criticism, and reporting have appeared in <I>Vogue, The New York Times, Slate, Salon, Yoga Journal, Real Simple, The Nation</I> and in newspapers around the country. She has taught writing at the University of Washington. A fourth-generation Seattle native, she lives with her family on Bainbridge Island in Puget Sound.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Macmillan
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?552c5534